import type {BioIconProps} from './common-types'

export function IconChevronRightThick({...attributes}: BioIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path d="M6.6901 18.3337L5.21094 16.8545L12.0651 10.0003L5.21094 3.14616L6.6901 1.66699L15.0234 10.0003L6.6901 18.3337Z" />
    </svg>
  )
}
